// extracted by css-extract-rspack-plugin
export default {"panel":"JA8mL","main":"HLlqq"};